import Vue from 'vue'
const defaultImg = require('../assets/product-default.png') 


var api = {
    init: function(){
        Vue.filter('asProductLargeImage', function(imageUrl){

            if(imageUrl){
                return imageUrl;
            }
        
            return defaultImg;
        });

        Vue.filter('asProductImage', function(imageUrl){

            if(imageUrl){
                if(imageUrl.indexOf('360buyimg.com') > 0){
                    return imageUrl.replace(/\/n0\//, '/n1/');
                }
                return imageUrl;
            }
        
            return defaultImg;
        });

        Vue.filter('asTagImage', function(imageUrl){

            if(imageUrl){
                return imageUrl;
            }
        
            return defaultImg;
        });
    }
}


export default api


// WEBPACK FOOTER //
// ./src/utils/filters.js